<template>
    <div class="flex justify-center">
        <div class="relative flex space-x-0.5 h-10 bg-transparent rounded-lg">
            <!-- decrement -->
            <button
                class="flex items-center justify-center w-10 text-gray-600 bg-gray-200 rounded-l hover:bg-gray-300 focus:outline-none disabled:opacity-50"
                :disabled="internalCount <= min"
                @click="decrement"
            >
                <span class="m-auto text-2xl font-thin">−</span>
            </button>

            <input
                :value="internalCount"
                type="number"
                :min="min"
                :max="max"
                class="w-20 text-center bg-gray-200 border-none appearance-none focus:ring-0"
                @input="onInputChange($event.target.value)"
            />

            <!-- increment -->
            <button
                class="flex items-center justify-center w-10 text-gray-600 bg-gray-200 rounded-r hover:bg-gray-300 focus:outline-none"
                :disabled="internalCount >= max"
                @click.stop="increment"
            >
                <span class="m-auto text-2xl font-thin disabled:opacity-50">+</span>
            </button>
        </div>
    </div>
</template>
<script>
    import _ from 'lodash';

    export default {
        name: 'CounterComponent',

        props: {
            currentCount: {
                type: Number,
                default: 1,
                required: true,
            },

            debounce: {
                type: Number,
                default: 2000,
            },
            min: {
                type: Number,
                default: 1,
            },
            max: {
                type: Number,
                default: 9999,
            },
            productId: {
                type: Number,
                default: null,
            },
        },

        data() {
            return {
                internalCount: this.currentCount ?? 1,
            };
        },

        watch: {
            currentCount(newVal) {
                console.log('Changed the count.', newVal);
                if (newVal !== this.internalCount) {
                    this.internalCount = newVal;
                }
            },
        },

        created() {
            this.countChanged = this.debounce ? _.debounce(this.countChanged, this.debounce) : this.countChanged;
        },

        methods: {
            countChanged() {
                this.$emit('countChanged', {
                    id: this.productId,
                    quantity: this.internalCount,
                });
            },

            onInputChange(value) {
                const parsed = parseInt(value.slice(0, 6)) || this.min;
                this.internalCount = Math.min(Math.max(val, this.min), this.max);
                this.countChanged();
            },

            increment() {
                if (this.internalCount < this.max) {
                    this.internalCount++;
                    this.countChanged();
                }
            },

            decrement() {
                console.log('decrement');
                if (this.internalCount > this.min) {
                    this.internalCount--;
                    this.countChanged();
                }
            },
        },
    };
</script>
